import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";

//
import { Spinner } from "react-bootstrap";

//
import { activateUser } from "../../redux/features/user/actions";

//
import Lock from "../../assets/img/user-images/lock.png";

//
import ImageBox from "../../components/general/ImageBox";

const Activate = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [responce, setResponce] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    activate_user();

    //eslint-disable-next-line
  }, []);

  /**
   * Activate User
   */
  const activate_user = () => {
    // start loading
    setLoading(true);

    // request
    activateUser(token).then((res) => {
      if (res) {
        setLoading(false);

        setResponce(true);

        setTimeout(() => {
          navigate("/auth/login");
        }, 2000);
      } else {
        setLoading(false);

        setResponce(false);
      }
    });
  };

  return (
    <>
      <ImageBox src={Lock} />
      <h4 className="mb-0">Account Verification</h4>

      <div className="account-verification-box">
        <div className={loading ? "text-center w-100" : "text-left "}>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" variant="info" />
            </div>
          ) : (
            <h5
              className={
                "m-0 title " + (responce ? "text-success" : "text-danger")
              }
            >
              {responce ? "Activation successfull" : "Activation failed"}
            </h5>
          )}
        </div>
      </div>

      <small>
        Wanna login to your account?
        <Link to="/auth/login" className="text-info fw-bolder">
          Login now
        </Link>
      </small>
    </>
  );
};
export default Activate;
